import { initializeJuniorRateState } from '@/modules/people/utils/initialize-junior-rate-state';
import { StatePayDetail } from '@/modules/people/store/employment';
import { JuniorRate } from '@/modules/people/types/employment';

/**
 * Seed one area group with the junior-rate state its rate row needs.
 *
 * Area groups carry their own junior state because each group has its own
 * contract and classification, so the junior rate one area resolves to is
 * independent of the main rate and of every other area.
 *
 * @param areaGroup - The area group to populate, mutated in place
 * @param juniorRates - Junior rates from the area group's contract
 * @param adultRate - The unreduced rate for this area group
 * @param dob - Employee's date of birth string
 * @param savedOverride - The persisted adult-rate choice, when there is one
 */
export function applyAreaGroupJuniorRateState(
  areaGroup: Record<string, unknown>,
  {
    juniorRates,
    adultRate,
    dob,
    savedOverride = undefined,
  }: {
    juniorRates: JuniorRate[] | undefined;
    adultRate: number | null | undefined;
    dob: string | null | undefined;
    savedOverride?: boolean | null | undefined;
  }
): void {
  initializeJuniorRateState(areaGroup as Partial<StatePayDetail>, {
    juniorRates,
    baseRate: adultRate,
    dob,
    overrideWithAdultRate: savedOverride,
  });
}
